import List from '@zenbusiness/zui/List';
import { styled } from '@zenbusiness/zui/styles';

export const FaqList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 3),
  gap: theme.spacing(1),
  listStyle: 'disc'
}));
